import { MenuApp } from '../layout/private/menu';
import { ROUTER_NAME } from '../router/routers';

/**
 * Returns the first permitted menu route for the given user.
 * For team members, it checks permissions against each menu item's permissionCodename.
 * For non-team-members / admins, it falls back to the default order route.
 *
 * @param {Object} params
 * @param {boolean} params.isTeamMember - Whether the user is a team member
 * @param {Array}   params.permissions  - Array of permission objects (each with a `codename` property)
 * @returns {string} The first permitted route path (e.g. '/order', '/analytics', etc.)
 */
export function getFirstPermittedRoute({ isTeamMember, permissions = [] }) {
    if (!isTeamMember) {
        return ROUTER_NAME.order;
    }

    const menu = MenuApp();

    const hasPermission = (item) => {
        if (!item.permissionCodename) return true;
        return permissions.some(perm => perm.codename === item.permissionCodename);
    };

    const firstAllowed = menu.find(item => !item.hide && hasPermission(item));

    if (firstAllowed) {
        return '/' + firstAllowed.route;
    }

    // Fallback if nothing is permitted
    return ROUTER_NAME.order;
}
